import MuiCssBaseline from "./MuiCssBaseline";
import MuiOutlinedInput from "./MuiOutlinedInput";
import MuiFormHelperText from "./MuiFormHelperText";
import MuiButton from "./MuiButton";
import MuiBackdrop from "./MuiBackdrop";
import MuiSlider from "./MuiSlider";
import MuiDialog from "./MuiDialog";

export default {
  overrides: {
    ...MuiCssBaseline,
    ...MuiOutlinedInput,
    ...MuiFormHelperText,
    ...MuiButton,
    ...MuiBackdrop,
    ...MuiDialog,
    ...MuiSlider,
  },
};
